module.exports = __webpack_public_path__ + "static/upturn-3e9dfa0267cf49bab20773f22ddbf5a1.png";